<p>
  <app-plugin [pluginItem]="pluginId" [userId]="user.uid"></app-plugin>
</p>
